/* eslint-disable max-classes-per-file */

export interface AllocateTourParams {
  contactFirstname: string;
  contactLastname: string;
  contactEmail?: string;
  contactPrefixPhone?: string;
  contactPhone?: string;
  contactChannel: string;
  contactLineId?: string;
  tourId: number;
  tourPeriodId: number;
  roomDetail?: {
    single: number;
    twin: number;
    triple: number;
    child: number;
    extraBed: number;
  };
  preferredContact: string[];
  key: string;
  [key: string]: number | string | undefined | any;
  sumPrice?: number;
  ttclid?: string;
  _ttp?: string;
}

export class ResponseDataInterface {
  bookingInternalNo: string;

  rsvnId: number;

  constructor(res: any) {
    this.bookingInternalNo = res?.bookingInternalNo || "";
    this.rsvnId = res?.rsvnId || 0;
  }
}

export class ResponseAllocateTour {
  status: boolean;

  message: string;

  data: ResponseDataInterface;

  constructor(res: any) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    // this.data = new PreAllocateTourInterface(res?.data);
    this.data = new ResponseDataInterface(res?.data);
  }
}
